import React, {
  FunctionComponent, PropsWithChildren, ReactElement,
} from 'react';
import { Image, ImageProps } from '@doveit/lego';
// eslint-disable-next-line import/no-cycle
import * as styles from './Stripe.style';

export enum StripeDirection {
  LEFT_TO_RIGHT = 'ltr',
  RIGHT_TO_LEFT = 'rtl',
}

export enum StripeAlignemnt {
  START = 'start',
  CENTER = 'center',
  END = 'end',
}

export type StripeProps = PropsWithChildren<{
  title: string,
  description: string,
  direction?: StripeDirection,
  alignContent?: StripeAlignemnt,
  picture?: ImageProps,
  imageSlot?: ReactElement,
}>;

export const Stripe: FunctionComponent<StripeProps> = ({
  picture,
  title,
  description,
  direction = StripeDirection.LEFT_TO_RIGHT,
  alignContent = StripeAlignemnt.CENTER,
  children,
  imageSlot,
}) => (
  <article
    css={styles.base}
    $direction={direction}
  >
    <div
      css={styles.picture}
      data-ref="stripe-picture"
    >
      {imageSlot || (
        <Image
          responsive
          {...picture}
        />
      )}
    </div>
    <div
      css={styles.content}
      $direction={direction}
      $alignContent={alignContent}
      data-ref="stripe-content"
    >
      <div>
        <h2
          css={styles.title}
          data-ref="stripe-title"
        >
          {title}
        </h2>
        <p
          css={styles.description}
          data-ref="stripe-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {children && (
          <div css={styles.actions}>
            {children}
          </div>
        )}
      </div>
    </div>
  </article>
);

export default Stripe;
